<template>
  <Head title="Kelola Pengumuman" />
  <Container>
    <template #header>
      <Header :menu="$page.props.main_menu" v-if="$page.props.auth.user" />
    </template>
    <template #default>
      <div>
        <Breadcrumbs
          :breadcrumbs="[
            { name: 'Dashboard', href: route('dashboard') },
            { name: 'Pengumuman', href: route('pengumuman.index') },
          ]"
        />

        <div class="grid grid-cols-1 gap-6 lg:grid-cols-3 lg:gap-8">
          <div class="order-2 col-span-1 space-y-6 lg:order-1">
            <div class="bg-white border border-gray-200 shadow-lg rounded-xl">
              <div
                class="px-4 py-3 border-b border-gray-200 bg-gradient-to-r from-indigo-500 to-purple-600 rounded-t-xl sm:px-6 sm:py-4"
              >
                <h2
                  class="flex items-center text-lg font-bold text-white sm:text-xl"
                >
                  <i class="mr-2 fa-solid fa-bullhorn sm:mr-3"></i>
                  {{ isEditMode ? "Edit Pengumuman" : "Tambah Pengumuman" }}
                </h2>
              </div>
              <div class="p-4 sm:p-6">
                <form class="space-y-4" @submit.prevent="submitForm">
                  <div>
                    <label class="block mb-2 text-sm font-medium text-gray-900"
                      >Teks Pengumuman</label
                    >
                    <textarea
                      v-model="form.pesan"
                      rows="4"
                      class="block w-full px-3 py-2.5 text-sm text-gray-900 bg-white border border-gray-300 rounded-lg shadow-sm placeholder:text-gray-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 hover:border-gray-400 transition-colors duration-200"
                      placeholder="Masukkan teks pengumuman yang akan berjalan"
                      required
                    ></textarea>
                    <div
                      v-if="form.errors.pesan"
                      class="mt-1 text-sm text-red-600"
                    >
                      {{ form.errors.pesan }}
                    </div>
                  </div>

                  <div>
                    <label class="block mb-2 text-sm font-medium text-gray-900"
                      >Urutan</label
                    >
                    <input
                      v-model="form.urutan"
                      type="number"
                      min="0"
                      class="block w-full px-3 py-2.5 text-sm text-gray-900 bg-white border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 hover:border-gray-400 transition-colors duration-200"
                    />
                  </div>

                  <div>
                    <label class="flex items-center">
                      <input
                        type="checkbox"
                        v-model="form.is_active"
                        class="w-4 h-4 text-indigo-600 border-gray-300 rounded focus:ring-indigo-500"
                      />
                      <span class="ml-2 text-sm text-gray-700">Aktif</span>
                    </label>
                  </div>

                  <div class="flex gap-3 pt-4">
                    <button
                      type="submit"
                      :disabled="form.processing"
                      class="flex-1 px-4 py-2.5 text-sm font-semibold text-white bg-indigo-600 rounded-lg shadow-sm hover:bg-indigo-700 disabled:opacity-50"
                    >
                      <i class="mr-2 fa-solid fa-floppy-disk"></i>
                      {{ form.processing ? "Menyimpan..." : "Simpan" }}
                    </button>
                    <button
                      v-if="isEditMode"
                      type="button"
                      @click="resetForm"
                      class="px-4 py-2.5 text-sm font-semibold text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50"
                    >
                      Batal
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>

          <div class="order-1 col-span-1 lg:col-span-2 lg:order-2">
            <div class="mb-4">
              <h3 class="text-lg font-semibold text-gray-900">
                Daftar Pengumuman
              </h3>
              <p class="mt-1 text-sm text-gray-600">
                Pengumuman yang aktif akan tampil sebagai running text di beranda.
              </p>
            </div>

            <div
              class="overflow-hidden bg-white shadow ring-1 ring-black ring-opacity-5 rounded-lg"
            >
              <ul class="divide-y divide-gray-200">
                <li
                  v-if="!pengumumans.data || pengumumans.data.length === 0"
                  class="px-6 py-12 text-center"
                >
                  <i
                    class="mb-3 text-4xl text-gray-400 fa-solid fa-bullhorn"
                  ></i>
                  <h3 class="text-lg font-medium text-gray-900">
                    Belum ada pengumuman
                  </h3>
                </li>
                <li
                  v-for="item in pengumumans.data || []"
                  :key="item.idpengumuman"
                  class="flex items-start justify-between gap-4 px-4 py-4 sm:px-6"
                >
                  <div class="flex-1 min-w-0">
                    <p class="text-sm font-medium text-gray-900">
                      {{ item.pesan }}
                    </p>
                    <div class="flex items-center gap-2 mt-1">
                      <span class="text-xs text-gray-500"
                        >Urutan: {{ item.urutan }}</span
                      >
                      <span
                        :class="
                          item.is_active
                            ? 'bg-green-100 text-green-800'
                            : 'bg-gray-100 text-gray-800'
                        "
                        class="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium"
                      >
                        {{ item.is_active ? "Aktif" : "Nonaktif" }}
                      </span>
                    </div>
                  </div>
                  <div class="flex items-center flex-shrink-0 gap-2">
                    <button
                      @click="toggleStatus(item)"
                      class="inline-flex items-center px-2.5 py-1.5 text-xs font-medium text-gray-700 bg-gray-100 rounded-md hover:bg-gray-200"
                      title="Toggle status"
                    >
                      <i
                        :class="item.is_active ? 'fa-eye-slash' : 'fa-eye'"
                        class="fa-solid"
                      ></i>
                    </button>
                    <button
                      @click="editItem(item)"
                      class="inline-flex items-center px-2.5 py-1.5 text-xs font-medium text-indigo-600 bg-indigo-100 rounded-md hover:bg-indigo-200"
                      title="Edit"
                    >
                      <i class="fa-solid fa-pen"></i>
                    </button>
                    <button
                      @click="deleteItem(item)"
                      class="inline-flex items-center px-2.5 py-1.5 text-xs font-medium text-red-600 bg-red-100 rounded-md hover:bg-red-200"
                      title="Hapus"
                    >
                      <i class="fa-solid fa-trash"></i>
                    </button>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </template>
  </Container>
</template>

<script setup>
import { ref } from "vue";
import { Head, useForm, router } from "@inertiajs/vue3";
import Container from "@/Layouts/Container.vue";
import Header from "@/Components/Header.vue";
import Breadcrumbs from "@/Components/Breadcrumbs.vue";
import Swal from "sweetalert2";

defineProps({
  pengumumans: {
    type: Object,
    required: true,
  },
});

const isEditMode = ref(false);
const editingId = ref(null);

const form = useForm({
  pesan: "",
  urutan: 0,
  is_active: true,
});

function resetForm() {
  isEditMode.value = false;
  editingId.value = null;
  form.reset();
  form.clearErrors();
}

function editItem(item) {
  isEditMode.value = true;
  editingId.value = item.idpengumuman;
  form.pesan = item.pesan;
  form.urutan = item.urutan;
  form.is_active = item.is_active;
}

function submitForm() {
  const onSuccess = () => {
    Swal.fire({
      title: "Berhasil!",
      text: `Pengumuman berhasil ${isEditMode.value ? "diperbarui" : "ditambahkan"}.`,
      icon: "success",
      timer: 2000,
      showConfirmButton: false,
    });
    resetForm();
  };
  const onError = () => {
    Swal.fire({
      title: "Gagal!",
      text: "Terjadi kesalahan saat menyimpan data.",
      icon: "error",
    });
  };

  if (isEditMode.value) {
    form.put(route("pengumuman.update", editingId.value), {
      onSuccess,
      onError,
      preserveScroll: true,
    });
  } else {
    form.post(route("pengumuman.store"), {
      onSuccess,
      onError,
      preserveScroll: true,
    });
  }
}

function toggleStatus(item) {
  router.put(
    route("pengumuman.toggle-status", item.idpengumuman),
    {},
    { preserveScroll: true }
  );
}

function deleteItem(item) {
  Swal.fire({
    title: "Apakah Anda yakin?",
    text: "Pengumuman ini akan dihapus secara permanen!",
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#dc2626",
    cancelButtonColor: "#6b7280",
    confirmButtonText: "Ya, hapus!",
    cancelButtonText: "Batal",
  }).then((result) => {
    if (result.isConfirmed) {
      router.delete(route("pengumuman.destroy", item.idpengumuman), {
        preserveScroll: true,
        onSuccess: () => {
          Swal.fire({
            title: "Berhasil!",
            text: "Pengumuman berhasil dihapus.",
            icon: "success",
            timer: 2000,
            showConfirmButton: false,
          });
        },
      });
    }
  });
}
</script>
